import React from "react";
import { Button } from "semantic-ui-react";
import classNames from "classnames";

const GreenGradientButton = ({ children, className, ...props }) => (
  <Button className={classNames("green-gradient-btn", className)} {...props}>
    {children}
  </Button>
);

export default GreenGradientButton;
